import React from 'react';
import getContactInfo from '../../lib/GetContactInfo';
import GeneralContactForm from '../Forms/GeneralContactForm';

function Forms() {
    // const formData = {
    //     recaptcha_token: '',
    //     fields: [{ label: '', value: '' }],
    // };

    return (
        <>
            <section className="contact-section">
                <div className="container">
                    <div className="row">
                        <div className="col-md-4 order-2 order-md-1">
                            <div className="contact--info-area">
                                <h3>Get in touch</h3>
                                <p>We would love to hear from you!</p>

                                <div className="single-info">
                                    <h5>Phone</h5>
                                    <p>
                                        <i className="fal fa-phone"></i>
                                        (+250) 788 381 832
                                    </p>
                                </div>
                                <div className="single-info">
                                    <h5>Support</h5>
                                    <p>
                                        <i className="fal fa-envelope"></i>
                                        {getContactInfo().email1}
                                        <br />
                                        {getContactInfo().email2}
                                    </p>
                                </div>
                                <div className="ab-social mb-3">
                                    <h5>Follow Us</h5>
                                    <a className="fac" href="https://facebook.com/kapprw">
                                        <i className="fab fa-facebook-f"></i>
                                    </a>
                                    <a className="ins" href="https://instagram.com/kapp.rw">
                                        <i className="fab fa-instagram"></i>
                                    </a>

                                    <a className="lin" href="https://linkedin.com/company/kapprw">
                                        <i className="fab fa-linkedin-in"></i>
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-8 order-1 mb-5 mb-md-0">
                            <div className="contact-form">
                                <h4>Let’s Connect</h4>
                                <p>
                                    If you have any questions, comments, or would like to learn more
                                    about our software solutions, please don't hesitate to get in
                                    touch.{' '}
                                </p>

                                <GeneralContactForm />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}

export default Forms;
